/* eslint-disable no-unused-vars */
import React, { useEffect, useCallback, useState } from 'react'
import styled from 'styled-components'
import { Route, Switch, useHistory, useRouteMatch } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import GridResponse from './components/layout/grid_response'
import AsideMedium from './components/medium/asideMedium'
import { LAYER_POPUP } from './reducers/initial'
import SEO from 'estimate_list/libs/seo'
import Index from './pages/index'
import Top from './pages/index/components/top'
import Estimate from './components/estimate/estimate'
import CategoryAD from './components/banner/categoryAD'
// import ShareLayer from './components/share/shareLayer'
import ShareLayer from './components/share/shareLayerReNew'
import Compare from './components/compare'
// import EstimateSave from './components/estimate_save'

import { LOG_IN_REQUEST } from './reducers/user'
import {
    SET_DOMAIN,
    SEARCH_DATA_REQUEST,
    SEARCH_PRICE_REQUEST,
    MINISHOP_INFO_REQUEST,
    SELECT_CATEGOTY,
} from './reducers/initial'
import { CATEGORY_REQUEST, CURRENT_CATEGORY_REQUEST } from './reducers/category'
import { setCompareItems, setCompareViewModal } from './libs/action'
import { estimate, scrollTo } from './libs/util'
import { useLocation } from "react-router";
import Analytics from './analytics'
// import DefaultLayer from "./components/layer/defaultLayer";
import EstimateFaqLayer from "./components/layer/estimateFaqLayer";
import StockLabelLayer from "./components/layer/stockLabelLayer";
import DefaultServiceModal from "./components/layer/defaultServiceModal";
// import DefaultTwoButtonLayer from "./components/layer/defaultTwoButtonLayer";
import DefaultOneButtonLayer from "./components/layer/defaultOneButtonLayer";
import YoutubeLayer from "./components/layer/youtubeLayer";
import { useParams } from 'react-router-dom';
import {itemAPI2} from "./libs/api2";

/**
 * 22-08-30
 * 개발 시 유의사항
 * - pc, shopping 등 개발 시 도메인 변경이 필요할 경우 직접 수정해서 사용해야함
 * 예시)
 * const DEV_DOMAIN = 'shopping'
 * const DEV_DOMAIN = 'pc'
 * @type {string}
 */


const DEV_DOMAIN = 'pc' // pc, shopping, minishop 개발 도메인 변경
const DEV_MINISHOP_NAME = 'kmemory' // 테스트 미니샵명
/**
 * 230710발생
 * window.shopID
 * 미니샵 sorry방지 (gcf -> minishop -> index -> shopID값 로컬에서 제대로 인식안됨)
 * 배포할때 주석해야함!!!!!!!!!!
 * */
// window.shopID='kmemory'

const App = () => {
    const dispatch = useDispatch()
    const history = useHistory()
    const { search } = useLocation()
    const match = useRouteMatch('/:mall_web_user/list/:cate_id')
    const { estimate_idx } = useParams();

    const {isOpenCompareViewModal, showStockLabelLayer, displayOnlyOneServiceAssembleModal, showYoutubeLayer, priceType} = useSelector(state => state.estimateAdd)

    const { layerPopup, domain, selectCategory, filterOptionAll, minishopInfo, lists } = useSelector((state) => state.initial)
    const objCateData = useSelector((state) => state.category.objCateData)
    const firstRoute = domain === 'minishop' ? '/:minishopName' : ''
    let defaultCategory = '1010100000' // cpu
    let domainName = window.location.hostname.split('.')[0] // pc, shopping(notebook), minishop
    if (domainName === 'notebook') {
        domainName = 'shopping'
        defaultCategory = '1050000000'
    }
    if (process.env.NODE_ENV === 'development') domainName = DEV_DOMAIN // 개발 도메인 변경
    const cate = window.location.pathname.split('/')[domainName === 'minishop' ? 3 : 2] || defaultCategory
    const minishopName = domainName === 'minishop' ? window.location.pathname.split('/')[1] : null
    if (domainName === 'minishop' && process.env.NODE_ENV === 'development') {
        !minishopName && history.push(`/${DEV_MINISHOP_NAME}`)
    }
    // 견적 리스트 로딩 체크
    const [isEstimateLoading,setIsEstimateLoading] = useState(true)

    // 행복 쇼핑 광고 컴포넌트 로딩 체크
    const [isAdLoading,setIsAdLoading] = useState(true)

    // 필터, 네이버 파워쇼핑 컴포넌트 로딩 체크
    const [isIndexLoading,setIsIndexLoading] = useState(true)

    // 서브 카테고리 클릭 여부 로딩 체크
    const [isScroll, setIsScroll] = useState(false)

    //url공유하기 idx값 추출 저장
    const [estimateIdx, setEstimateIdx] = useState(estimate_idx)

    useEffect(() => {
        setEstimateIdx(estimate_idx)
    },[estimateIdx])

    useEffect(() => {
        if (isScroll){
            if (!isEstimateLoading && !isAdLoading && !isIndexLoading){
                if (cate === '1010100000'){
                    scrollTo('#layout_list_group', -420, )
                } else {
                    scrollTo('#layout_list_group', -100, )
                }
                setIsScroll(false)
            }
        }
    }, [isEstimateLoading,isAdLoading,isIndexLoading,isScroll,cate]);



    useEffect(() => {
        getDomain() // set domain
        domainName === 'minishop' && getMinishopInfo() // set minishop 정보
        fetchSelectCategory() // set selectcategory
        fetchUser() // set user
        urlChecker() // url 검사
        if(estimate_idx) {
            setEstimateIdx(estimate_idx)
        }
    }, []) // eslint-disable-line

    useEffect(()=>{
        /**
         * Alias
         * */
        if(domainName!=='pc' && domainName!=='minishop'){
            itemAPI2.getAlias(cate).then(res=>{ // pc, minishop 아닐경우 alias 여부 확인
                const data = res?.data
                if(data){
                    const replaceUrl = data?.aliasUrl ? data?.aliasUrl : 'shopping'
                    if(window.location.hostname.split('.')[0]!==replaceUrl){  // 변경전 주소,카테고리 같지않을때만
                        if(replaceUrl!=='shopping'){ // aliasUrl이 있을 경우 redirect, 없을 경우 그냥 냅둠
                            window.location.href=`//${replaceUrl}.pping.${process.env.REACT_APP_TLD}/list/${cate}`
                        }else{
                            window.location.href=`${process.env.REACT_APP_SHOPPING_URL}/list/${cate}`
                        }
                    }
                }
            })
        }
    },[cate])

    useEffect(() => {
        if (domainName === 'minishop') {
            if (minishopInfo === false) {
                if (process.env.NODE_ENV === 'development') {
                    history.push(`/${DEV_MINISHOP_NAME}/list/${defaultCategory}`)
                }
                /*else {
                    window.location.href = process.env.REACT_APP_PC_URL
                }*/
            }
            minishopInfo && getCategory(minishopInfo.idx_b_manager) // set 카테고리
        } else {
            getCategory(1) // set 카테고리
        }
    }, [minishopInfo]) // eslint-disable-line

    useEffect(() => {
        fetchSearchData() // set 검색필터 데이터
        fetchSearchPrice() // set 검색가격 데이터
        estimate.delCompareAllItems() // 상품비교 reset
        dispatch(setCompareItems([])) // 상품비교 reset
        getCurrentCategory() // 현재카테고리 정보

        if (selectCategory === undefined) {
            fetchSelectCategory()
        }
    }, [selectCategory]) // eslint-disable-line

    useEffect(() => {
        // 잘못된 카테고리 접근시
        if (objCateData) {
            if (domainName === 'minishop' && (minishopInfo === null || minishopInfo?.f_minishop === 1 && minishopInfo?.f_estimate === 0 && minishopInfo?.f_auth_unit === 0)) {
                // console.log('실행')
            } else {
                const f_div = objCateData?.[cate]?.f_div

                if (f_div === 1 && domainName === 'pc' ) {
                    window.location.href = '//' + window.location.host
                } else if (f_div === undefined) {
                    window.location.href = '//' + window.location.host
                }
            }
        }
    }, [objCateData, cate, domainName])

    const getDomain = () => {
        dispatch({
            type: SET_DOMAIN,
            data: domainName,
        })
    }

    const getMinishopInfo = () => {
        const minishopName = window.location.pathname.split('/')[1]
        dispatch({
            type: MINISHOP_INFO_REQUEST,
            data: minishopName,
        })
    }

    const fetchSelectCategory = (data) => {
        dispatch({
            type: SELECT_CATEGOTY,
            data: data || cate,
        })
    }

    const fetchUser = () => {
        dispatch({
            type: LOG_IN_REQUEST,
        })
    }

    const fetchSearchData = () => {
        dispatch({
            type: SEARCH_DATA_REQUEST,
            data: cate,
        })
    }

    const fetchSearchPrice = () => {
        dispatch({
            type: SEARCH_PRICE_REQUEST,
            data: cate,
        })
    }

    const getCategory = (idx) => {
        dispatch({
            type: CATEGORY_REQUEST,
            data: idx,
        })
    }

    const getCurrentCategory = () => {
        dispatch({
            type: CURRENT_CATEGORY_REQUEST,
            data: cate,
        })
    }

    const closeLayerPopup = useCallback(() => {
        dispatch({
            type: LAYER_POPUP,
            data: null,
        })
    }, [dispatch])

    const urlChecker = () => {
        if (domainName === 'minishop') {
            if (!minishopName) {
                window.location.href = process.env.REACT_APP_PC_URL
                return
            }
        } else {
            const prevCate = window.location.pathname.split('/')[1]
            if (Number(prevCate) > 0 && prevCate.length === 10) {
                history.push(`/list/${prevCate}`)
                return
            }
        }
        if (!cate || !(Number(cate) > 0)) {
            fetchSelectCategory(defaultCategory) // 카테고리코드 없을시 기본카테고리 넣음
            if (domainName === 'minishop') {
                history.push(`/${minishopName}/list/${defaultCategory}`)
            } else {
                //history.push(`/list/${defaultCategory}`)
            }
        }
    }

    useEffect( () => {
        if(lists.advList || lists.curation){
            if(search.includes("ad_code")) {
                let queryStringAdCode = new URLSearchParams(search).get('ad_code');
                let timer = setTimeout(() => {
                    let element;
                    if (queryStringAdCode === 'svp001' || queryStringAdCode === 'svp002') {
                        clearTimeout(timer)
                        setTimeout(() => {
                            element = document.getElementById(`nav_spy`);
                            scrollTo('#nav_spy', element.scrollHeight - 100, 'smooth')
                        }, 5000)
                    } else if (queryStringAdCode === 'dap020' || queryStringAdCode === 'dap006') {
                        element = document.getElementById('listAdvStickAd');
                    } else if (queryStringAdCode === 'dap012' || queryStringAdCode === 'dap004') {
                        clearTimeout(timer)
                        setTimeout(() => {
                            window.scrollTo({
                                top: 0,
                                left: 0,
                                behavior: 'smooth'
                            })
                        }, 1500)
                    } else {
                        element = document.getElementById(`${queryStringAdCode}_ad`);
                    }
                    element && element.scrollIntoView({behavior: 'smooth'});
                }, 2500);
            }
        }
    }, [search, lists.advList, lists.curation]);

    return (
        <>
            {domainName === 'minishop' && (minishopInfo === null || minishopInfo?.f_minishop === 1 && minishopInfo?.f_estimate === 0 && minishopInfo?.f_auth_unit === 0) ? (
                    <></>
                ):
                (<Wrap domainName={domainName}>
                    {objCateData?.[selectCategory]?.cate_name && (
                        <>
                            {domainName === 'minishop' && (
                                <SEO
                                    title={`${minishopInfo.mall_name}${match ? ` ${objCateData[selectCategory].cate_name}` : ''} PC견적 : 행복쇼핑`}
                                    description={`${minishopInfo.mall_name}${match ? ` ${objCateData[selectCategory].cate_name}` : ''} PC견적 : 최저가 보장 가격비교 사이트, 온라인 쇼핑몰 비교는 행복쇼핑`}
                                    ogTitle={`${minishopInfo.mall_name}${match ? ` ${objCateData[selectCategory].cate_name}` : ''} PC견적 : 행복쇼핑`}
                                    ogSiteName={`${minishopInfo.mall_name}${match ? ` ${objCateData[selectCategory].cate_name}` : ''} PC견적 : 행복쇼핑`}
                                />
                            )}
                        </>
                    )}
                    <GridResponse
                        main={
                            <div
                                className="main_contents"
                                style={{ overflowAnchor: `${filterOptionAll ? 'none' : 'visible'}` }}
                            >
                                <Top />
                                <Analytics />
                                <div className="list-body estimate_compare">
                                    <div className="list-body_items">{domain !== 'shopping' && <Estimate setIsEstimateLoading={setIsEstimateLoading} estimateIdx={estimateIdx}/>}</div>
                                </div>
                                <CateAdWrap>{domain && <CategoryAD setIsAdLoading={setIsAdLoading}/>}</CateAdWrap>
                                <Switch>
                                    {/*<Route path={`${firstRoute}/popup/estimateSave`} component={EstimateSave} />*/}
                                    {/*
                                        http://react.pping.kr:3000/runcom/list/1010100000
                                        /runcom/list/1010100000/srch/total/list/1/rank/30/
                                        상품분류 전체보기, 검색(기본), 탭, 노출타입, 페이지, 정렬조건, 노출개수, 검색조건
                                     */}
                                    <Route
                                        path={`${firstRoute}/list/:categoryID/srch/:tab/:types/:page/:sort/:size/:srch_cond`}
                                        render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />}
                                    />
                                    <Route
                                        path={`${firstRoute}/list/:categoryID/srch/:tab/:types/:page/:sort/:size`}
                                        render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />}
                                    />
                                    <Route
                                        path={`${firstRoute}/list/:categoryID/srch/:tab/:types/:page/:sort`}
                                        render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />}/>

                                    <Route path={`${firstRoute}/list/:categoryID/srch/:tab/:types/:page`} render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />}/>

                                    <Route
                                        path={`${firstRoute}/list/:categoryID/srch/:tab/:types`}
                                        render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />} />

                                    <Route
                                        path={`${firstRoute}/list/:categoryID/srch/:tab`}
                                        render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />}/>

                                    <Route
                                        path={`${firstRoute}/list/:categoryID/srch`}
                                        render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />} />

                                    <Route
                                        path={`${firstRoute}/list/:categoryID/:tab`}
                                        render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />}/>

                                    <Route
                                        path={`${firstRoute}/list/:categoryID`}
                                        render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />} />

                                    <Route
                                        path={`${firstRoute}/list`}
                                        render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />}  />

                                    {estimateIdx
                                        ? <></>
                                        : <Route
                                            path={`${domain === 'minishop' ? '/:minishopName' : '/'}`}
                                            render={()=><Index setIsIndexLoading={setIsIndexLoading} setIsScroll={setIsScroll} cateName={objCateData?.[selectCategory]?.cate_name} />}
                                        />
                                    }
                                </Switch>
                            </div>
                        }
                        sub={<>{selectCategory && <AsideMedium />}</>}
                    />
                    <Compare />
                    <div className="layer_group_field">
                        {layerPopup === 'share' && <ShareLayer priceType={priceType} mallInfo={minishopInfo} domainName={domainName} onClose={closeLayerPopup} />}
                        {isOpenCompareViewModal && (
                            // <DefaultLayer onClose={() => dispatch(setCompareViewModal(false))} padding='55px'>
                            //     <p>한번에 비교 가능한</p>
                            //     <p>상품수는 <font className="clrpont1">최대 10개</font> 입니다.</p>
                            // </DefaultLayer>
                            <DefaultOneButtonLayer onClose={() => dispatch(setCompareViewModal(false))} text={`<span>한번에 비교 가능한<br/> 상품수는 <b>최대 10개</b> 입니다.</span>`}/>
                        )}
                    </div>
                    {layerPopup === 'orange' && <EstimateFaqLayer/>}

                    {/*재고인증 라벨 레이어*/}
                    {showStockLabelLayer && <StockLabelLayer/>}

                    {/*조립 서비스 중복 구매 방지 레이어*/}
                    {/*조립 서비스는 1개만 선택 하실 수 있습니다*/}
                    {displayOnlyOneServiceAssembleModal.isOpen && <DefaultServiceModal/>}
                    {showYoutubeLayer && <YoutubeLayer/>}
                    {/*<TwoButtonLayer/>*/}
                </Wrap>
            )}
        </>
    )
}

const Wrap = styled.div`
    padding: 15px 0 0;

    * {
        box-sizing: border-box
    }
    button {
        border: 0;
        background: none;
    }
    .main_contents {
        position: relative;
    }

    /* v4 사용으로 인해 깨지는부분 수정 */
    .list-body {
        margin-bottom: 0;
        padding-top: 0;
    }
    .list-body_items_share {
        margin: 10px 0 0;
    }
    .estimate_compare {
        * {
            box-sizing: content-box
        }
        .istyle {
            box-sizing: border-box
        }
        .list-body_items {
            .estiList{
                .compare_add_service{
                    .layer-pop{
                        ::before{
                            background-color: rgb(0,0,0,0.75);
                        }
                    }
                }
                .layer-pop{
                    ::before{
                        background-color: rgb(0,0,0,0.75);
                    }
                }

                .box-board{
                    .board{
                        tbody{
                            tr{
                                td{
                                    .layer-common-confirm{
                                        ::before{
                                            background-color: rgb(0,0,0,0.75);
                                        }

                                        .layer-common-confirm-wrap{
                                        }
                                    }
                                }
                            }

                        }
                    }
                }
            }
        }
        //&.guide-powerSeller{
        //    box-sizing: border-box;
        //}
    }
    .aside-medium {
        position: relative;
        margin: 0 0 0 0;
        height: calc(100% - 10px)
    }
    .icheck label:before, .iradio label:before {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        padding: 3px;
        margin-right: 5px;
    }
    .iradio input:checked+label:after {
        width: 16px;
        height: 16px;
        left: 4px;
        top: 4px;
        margin-top: 0;
    }
    .layer-pop_comm_confirm *,
    .layer-common-confirm-button-group {
        box-sizing: border-box
    }
    .layer-pop_osbuy .btn-add-to {
        background: #418ded
    }
    .list-body .list-body_items .cart-body_compare_other {
        margin: 0
    }
    .list-body .list-body_items .estiList {
        margin: 0 0 30px;
    }
    .items_compare_body_list_item_bot {
        .icheck label:before, .iradio label:before {
            width: 16px!important;
            height: 16px!important;
            padding: 0;
        }
    }
    .items_compare {
        width: ${props => props.domainName === 'shopping' ? '950px !important' : '890px !important'};
    }
    .items_compare_body_list {
        width: ${props => props.domainName === 'shopping' ? 'calc(950px - 191px) !important' : 'calc(890px - 191px) !important'};
    }
    .list-body .list-body_items .list-body_items_main .list-body_items_main_box .items_compare {
        left: ${props => props.domainName === 'shopping'? 'calc(50% - 595px)' : 'calc(50% - 535px)'};

        @media only screen and (max-width: 1209px) {
            left: ${props => props.domainName === 'shopping'? 'calc(50% - 475px) !important' : 'calc(50% - 415px) !important'};
        }
        @media only screen and (max-width: 960px) {
            width: ${props => props.domainName === 'shopping'? '100% !important' : 'calc(100% - 60px) !important'};
            left: 0 !important;
            margin-left: ${props => props.domainName === 'shopping'? '0px' : '60px'};
        }

    }
    .icon-navertalk_01.ntkBtn {
        box-sizing: border-box
    }
    /* custom */
    .list-body .list-body_items .estiList {
        position: relative
    }
`

const CateAdWrap = styled.div``

export default App



// WEBPACK FOOTER //
// ./src/estimate_list/App.js